import { AppState } from '../stores';
import FinishSignInModal from '../../components/misc/FinishSignInModal.svelte';
export function useInternalModal() {
    const open = (component, options) => {
        AppState.update(previousState => (Object.assign(Object.assign({}, previousState), { website: Object.assign(Object.assign({}, previousState.website), { internalModal: {
                    component,
                    options,
                    isVisible: true
                } }) })));
    };
    const close = () => {
        AppState.update(previousState => (Object.assign(Object.assign({}, previousState), { website: Object.assign(Object.assign({}, previousState.website), { internalModal: Object.assign(Object.assign({}, previousState.website.internalModal), { isVisible: false }) }) })));
    };
    return {
        open,
        close
    };
}
/**
 * Custom modals open methods below
 */
export function useFinishSignIn() {
    const { open, close } = useInternalModal();
    return {
        open: () => open(FinishSignInModal, { disabledClose: true }),
        close
    };
}
